import {
  APPROVE_WALLET_TRANSACTION_START,
  APPROVE_WALLET_TRANSACTION_SUCCESS,
  APPROVE_WALLET_TRANSACTION_ERROR,
  APPROVE_WALLET_TRANSACTION_RESET,
} from 'constants/action-types/wallets/approveWalletTransaction';

export default (state, { type, payload }) => {
  switch (type) {
    case APPROVE_WALLET_TRANSACTION_RESET:
      return {
        ...state,
        approveWalletTransaction: {
          ...state.approveWalletTransaction,
          message: null,
          loading: false,
          error: null,
        },
      };
    case APPROVE_WALLET_TRANSACTION_START:
      return {
        ...state,
        approveWalletTransaction: {
          ...state.approveWalletTransaction,
          message: null,
          loading: true,
          error: null,
        },
      };
    case APPROVE_WALLET_TRANSACTION_ERROR:
      return {
        ...state,
        approveWalletTransaction: {
          ...state.approveWalletTransaction,
          error: payload,
          loading: false,
          message: null,
        },
      };
    case APPROVE_WALLET_TRANSACTION_SUCCESS:
      return {
        ...state,
        approveWalletTransaction: {
          ...state.approveWalletTransaction,
          error: null,
          message: payload.message,
          loading: false,
        },
      };
    default:
      return null;
  }
};
